function initAutocomplete() {
    //Init autocomplete parameters and finding ID
    var options = {
        componentRestrictions: { country: "us" },
        fields: ["name", "geometry"]
    };
    var input_id = document.getElementById("autocomplete");

    //Init autocomplete
    var autocomplete = new google.maps.places.Autocomplete(input_id, options);

    google.maps.event.addListener(autocomplete, "place_changed", () => {
        var place = autocomplete.getPlace();

        //Init lat and lng of users current location
        var current_lat = place.geometry.location.lat();
        var current_lng = place.geometry.location.lng();
        var current_address_name = place.name;

        //Set lat and lng of current location to hidden field
        document.getElementById("js-current_lat").value = current_lat;
        document.getElementById("js-current_lng").value = current_lng;
        document.getElementById(
            "js-current_address_name"
        ).value = current_address_name;
    });
}

loadJSArrayOnIntersection(".c-find-widget #autocomplete", ['https://maps.googleapis.com/maps/api/js?key=AIzaSyBrgostRSe5yBznp2Oo4jkEwZoj5sPSXsw&callback=initAutocomplete&libraries=places,geometry&v=weekly']);